<template>
	<div class="box">
		<!-- 新建区域功能区-->
		<el-row :gutter="20">
			<el-col :span="2">
				<el-button size="small" @click="back">返回</el-button>
			</el-col>
			<el-col :span="12" :offset="10" style="text-align: right">
				<div class="grid-content bg-purple">
					<el-button
						type="primary"
						size="small"
						@click="on_fullscreen = !on_fullscreen"
						>全屏</el-button
					>
					<el-button type="primary" size="small" @click="addCard()"
						>新建会场区域</el-button
					>
					<el-button type="warning" size="small" @click="generateimg"
						>生成座位图</el-button
					>
					<el-button type="info" size="small" @click="isSet"
						>设置</el-button
					>
					<el-button type="primary" size="small" @click="sendMessage"
						>发送座位信息</el-button
					>
					<el-button
						type="success"
						size="small"
						@click="save"
						style="background-color: #009688; border-color: #009688"
						>保存</el-button
					>
				</div>
			</el-col>
		</el-row>
		<!-- 卡片 -->
		<div id="card">
			<el-card class="box-card" v-for="(item, i) in cards" :key="i">
				<div slot="header" class="clearfix">
					<span class="titile">{{ item.name }}</span>
					<br />
					<el-button
						style="padding: 8px 8px"
						@click="remove(item.numbered)"
						>删除</el-button
					>
					<el-button
						style="padding: 8px 8px"
						@click="
							editCard(
								item.name,
								item.line,
								item.column,
								item.numbered,
								item.seat
							)
						"
						>编辑</el-button
					>
					<el-button
						style="padding: 8px 8px"
						@click="seating(i, item.seat)"
						type="primary"
						>自动排座位号</el-button
					>
				</div>
				<div class="text item">行数：{{ item.line }}</div>
				<div class="text item">列数：{{ item.column }}</div>
				<div class="text item">编号：{{ item.numbered }}</div>
				<div class="text item">起始位置：{{ item.seat }}</div>
			</el-card>
		</div>

		<div :class="['fullscreen_container', on_fullscreen && 'on_fullscreen']">
			<el-button
				v-if="on_fullscreen"
				type="primary"
				size="small"
				style="margin: 10px"
				@click="on_fullscreen = !on_fullscreen"
				>退出全屏</el-button
			>
			<!-- 其他功能按钮 -->
			<div class="btbox">
				<el-collapse
					:accordion="false"
					style="background-color: white; margin-bottom: 10px"
					v-model="activeNames"
				>
					<el-collapse-item
						style="padding: 0px 20px 0px 20px"
						name="1"
					>
						<template slot="title">
							<p
								style="
									font-size: 14px;
									font-weight: 600;
									margin-bottom: 0px;
								"
							>
								<i
									class="header-icon el-icon-s-flag"
									style="color: #409eff; margin-right: 5px"
								></i>
								座位设置
							</p>
						</template>
						<el-button
							type="primary"
							size="small"
							@click="change_rows(row)"
							>修改行号</el-button
						>
						<el-button type="primary" size="small" @click="modify"
							>修改座位号</el-button
						>
						<el-button
							:class="{ actives: standard == 1 }"
							size="small"
							@click="jy"
							>禁用座位</el-button
						>
						<el-button
							:class="{ actives: standard == 2 }"
							size="small"
							@click="ckSeat"
							>占用座位</el-button
						>
						<el-select
							v-model="values"
							placeholder="请选择标记颜色"
							size="small"
							style="
								margin-left: 10px;
								margin-right: 10px;
								width: 145px;
							"
							clearable
						>
							<el-option
								v-for="(item, i) in options"
								:key="i"
								:label="item.label"
								:value="item.value"
							>
								<span style="float: left">{{
									item.label
								}}</span>
								<span
									style="float: right; font-size: 13px"
									:style="{ color: item.value }"
									>{{ item.value }}</span
								>
							</el-option>
						</el-select>
						<el-button
							:class="{ actives: standard == 3 }"
							size="small"
							@click="tag_colors"
							>颜色标记</el-button
						>
						<el-button
							:class="{ actives: standard == 0 }"
							size="small"
							@click="nocheck"
							>无状态</el-button
						>
						<el-button
							type="primary"
							size="small"
							@click="dialogVisibless = true"
							style="
								background-color: #009688;
								border-color: #009688;
							"
							>+增加标记</el-button
						>
						<el-button
							type="primary"
							size="small"
							@click="removebiaoji = true"
							style="
								background-color: #009688;
								border-color: #009688;
							"
							>-删除标记</el-button
						>
					</el-collapse-item>
					<el-collapse-item
						style="padding: 0px 20px 0px 20px"
						name="2"
					>
						<template slot="title">
							<p
								style="
									font-size: 14px;
									font-weight: 600;
									margin-bottom: 0px;
								"
							>
								<i
									class="header-icon el-icon-s-flag"
									style="color: #409eff; margin-right: 5px"
								></i>
								嘉宾设置
							</p>
						</template>
						<div style="overflow: hidden">
							<div style="float: left">
								<el-button
									type="primary"
									size="small"
									@click="newuser"
									>新增嘉宾</el-button
								>
								<el-select
									v-model="typeval"
									placeholder="请选择导入/导出类型"
									class="type_daochu"
									size="small"
									clearable
								>
									<el-option
										v-for="item in typedaochu"
										:key="item.value"
										:label="item.label"
										:value="item.value"
									></el-option>
								</el-select>
							</div>
							<div
								style="
									display: inline-block;
									margin-left: 10px;
									float: left;
								"
							>
								<el-upload
									class="upload-demo"
									action="/ac1/upload/oneFile"
									:on-success="fileok"
									:on-error="fileno"
									:auto-upload="true"
									:multiple="false"
									:limit="1"
									:on-remove="removefile"
									:on-exceed="overflows"
									accept=".xls, .xlsx"
									:show-file-list="true"
								>
									<el-button slot="trigger" size="small"
										>选择文件</el-button
									>
									<el-button
										style="margin-left: 10px"
										size="small"
										type="primary"
										@click="submitUpload"
										>批量导入</el-button
									>
									<el-button
										type="primary"
										size="small"
										@click="daochuex"
										>批量导出</el-button
									>
									<el-button
										size="small"
										@click="download"
										style="margin-left: 10px"
										>下载导入嘉宾名单模板</el-button
									>
								</el-upload>
							</div>
						</div>
					</el-collapse-item>
					<el-collapse-item
						style="padding: 0px 20px 0px 20px"
						name="3"
					>
						<template slot="title">
							<p
								style="
									font-size: 14px;
									font-weight: 600;
									margin-bottom: 0px;
								"
							>
								<i
									class="header-icon el-icon-s-flag"
									style="color: #409eff; margin-right: 5px"
								></i>
								排座位
								<span
									style="
										font-size: 12px;
										font-weight: normal;
										margin-left: 100px;
									"
								>
									已排:
									<span style="color: red">{{
										scheduled
									}}</span>
									/{{ notarranged }}
								</span>
							</p>
						</template>
						<p
							style="
								font-size: 12px;
								padding: 13px 10px;
								background-color: lavender;
							"
						>
							<i
								class="header-icon el-icon-info"
								style="color: #e6a23c; margin-right: 5px"
							></i
							>点击左侧空余位置后再点击右侧未安排座位的嘉宾名称,即可将嘉宾安排入座位.(实线边框代表未排座位，虚线边框代表已排座位)
						</p>
						<div>
							<el-button
								:class="{ actives: standard == 4 }"
								size="small"
								@click="removekehu"
								>移除嘉宾</el-button
							>
							<el-button
								type="danger"
								size="small"
								@click="removeall"
								>移除全部嘉宾</el-button
							>
							<el-button
								type="primary"
								size="small"
								@click="piliang"
								>批量排入座位</el-button
							>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>

			<!-- 座位图 -->
			<div class="seat_box" style="width: 100%; height: auto; display: flex">
				<!-- 座位区域 -->
				<div :class="['waibian', dragable && 'waibian_on_dragable']">
					<div id="boxs" class="boxs" ref="qrCodeDiv">
						<div
							v-for="(items, i) in conferenceSeats"
							:key="i"
							class="zhe"
							:id="'numbered' + items.numbered"
						>
							<div class="left_box">
								<el-tag
									style="
										margin-bottom: 10px;
										margin-right: 10px;
									"
									>区域名称：{{ items.area }}</el-tag
								>
								<el-tag style="margin-bottom: 10px"
									>区域编号：{{ items.numbered }}</el-tag
								>
								<template
									v-for="(itemss, index) in items.array_seat"
								>
									<ul class="nos" :key="index">
										<li
											v-for="(itemss2, indexs) in itemss"
											:key="indexs"
											:id="
												'id' +
												items.numbered +
												itemss2.line +
												itemss2.column
											"
											:user_id="itemss2.member.member.id"
											@click="
												currentInfo(
													itemss2.line,
													itemss2.column,
													items.numbered,
													itemss2.seats,
													itemss2.row,
													itemss2
												)
											"
											:class="{
												active: ind == 'id+' + items.numbered + itemss2.line + itemss2.column,
												jy: itemss2.checkDisabledState == true,
												ckSeat: itemss2.seat_t == true,
												xuan: itemss2.member.member.membercheck == true,
												seat_active: active_seat_id == 'id+' + items.numbered + itemss2.line + itemss2.column
											}"
											:style="{
												background: itemss2.color,
											}"
										>
											<span
												v-if="
													itemss2.checkDisabledState ==
													true
												"
												>已禁用</span
											>
											<span
												v-else-if="
													itemss2.seat_t == true
												"
												>占座</span
											>
											<span
												v-else-if="
													itemss2.member.member
														.membercheck == true
												"
												>{{
													itemss2.member.member.name
												}}</span
											>
											<span v-else
												>{{ itemss2.row
												}}{{ itemss2.seats }}</span
											>
										</li>
									</ul>
								</template>
							</div>
						</div>
					</div>
				</div>
				<!-- 参会用户区域 -->
				<div :class="['order_user', !dragable && 'order_user_on_drag_disabled']">
					<VueDragResize class="dragable_user_box" :style="{maxHeight: !dragable ? `${dragable_user_box_max_height}px` : 'unset'}" :isActive="true" :w="500" :h="300" :y="60 + 50" :x="main_panel_box_width - 500 - 60" v-on:resizing="resize" v-on:dragging="resize" :sticks="['br']" @activated="index => activateEv(index)">
						<div :class="['clickbar', dragable && '']">
							<el-icon :class="['icon', dragable ? 'el-icon-close' : 'el-icon-upload2']" @click.native="dragable = !dragable;" />
						</div>
						<div class="title_bar">
							<el-input
								ref="drag_input"
								class="inline-input drag_input"
								v-model="title_bar_drag_model"
								placeholder="请输入内容"
								size="small"
							/>
							<el-select class="select_filter" v-model="title_bar_filter_index" placeholder="请选择" size="small">
								<el-option
									v-for="item in title_bar_options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								/>
							</el-select>
						</div>
						<div class="box_wrapper">
							<el-tooltip
								placement="right"
								v-for="(Customeritem, i) in filtered_user_list"
								:key="i"
								hide-afte="30"
								:enterable="false"
							>
								<div slot="content">
									姓名：{{ Customeritem.name }}
									<br />
									电话：{{ Customeritem.tel }}
									<br />
									职称：{{ Customeritem.job }}
									<br />
									部门：{{ Customeritem.dep }}
									<br />
									机构：{{ Customeritem.team }}
									<br />
									区域编号:{{ Customeritem.numbered }}
									<br />
									座位信息：{{ Customeritem.row
									}}{{ Customeritem.seats }}
									<br />
									是否有座：{{
										Customeritem.membercheck ? "有座" : "无座"
									}}
								</div>
								<el-button
									class="userbt"
									:class="[Customeritem.membercheck ? 'active has_seat' : 'no_seat', Customeritem.id == active_user_id && 'userbt_active']"
									:id="Customeritem.id"
									@click="clickpeople(Customeritem.id)"
								>
									{{ Customeritem.name }}
								</el-button>
							</el-tooltip>
						</div>
					</VueDragResize>
				</div>
			</div>
		</div>
		<!-- 座位弹窗 -->
		<el-dialog
			title="排座位"
			:visible.sync="centerDialogVisible"
			:close-on-click-modal="false"
			:before-close="close"
			width="40%"
			left
		>
			<span>
				<el-form
					ref="form"
					:model="form"
					label-width="110px"
					:rules="rules"
				>
					<el-form-item label="区域名称" prop="name">
						<el-input v-model="form.name"></el-input>
					</el-form-item>
					<el-form-item
						label="行数"
						prop="line"
						:rules="[
							{ required: true, message: '行数不能为空' },
							{ type: 'number', message: '行数必须为数字值' },
						]"
					>
						<el-input v-model.number="form.line"></el-input>
					</el-form-item>
					<el-form-item
						label="列数"
						prop="column"
						:rules="[
							{ required: true, message: '列数不能为空' },
							{ type: 'number', message: '列数必须为数字值' },
						]"
					>
						<el-input v-model.number="form.column"></el-input>
					</el-form-item>
					<el-form-item
						label="编号"
						prop="numbered"
						:rules="[
							{ required: true, message: '编号不能为空' },
							{ type: 'number', message: '编号必须为数字值' },
						]"
					>
						<el-input
							v-model.number="form.numbered"
							:disabled="disabled"
						></el-input>
					</el-form-item>
					<el-form-item label="座位起始位置" prop="seat">
						<el-select
							v-model="form.seat"
							placeholder="请选择座位起始位置"
						>
							<el-option label="左" value="left"></el-option>
							<el-option label="中左" value="center"></el-option>
							<el-option
								label="中右"
								value="center_right"
							></el-option>
							<el-option label="右" value="right"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="close()">取 消</el-button>
				<el-button type="primary" @click="subCard()">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 编辑座位弹窗 -->
		<el-dialog
			:title="editform.name"
			:visible.sync="editcenterDialogVisible"
			:close-on-click-modal="false"
			:before-close="editClose"
			width="40%"
			left
		>
			<span>
				<el-form
					ref="editform"
					:model="editform"
					label-width="130px"
					:rules="rules"
				>
					<!-- <el-form-item
            label="添加行数"
            prop="line"
            :rules="[
              { required: true, message: '行数不能为空' },
              { type: 'number', message: '行数必须为数字值' }
            ]"
          >
            <el-input v-model.number="editform.line"></el-input>
          </el-form-item>
          <el-form-item
            label="添加列数"
            prop="column"
            :rules="[
              { required: true, message: '列数不能为空' },
              { type: 'number', message: '列数必须为数字值' }
            ]"
          >
            <el-input v-model.number="editform.column"></el-input>
          </el-form-item>-->
					<el-form-item label="座位排号起始位置">
						<el-select
							v-model="editform.seats"
							placeholder="请选择活动区域"
						>
							<el-option label="左" value="left"></el-option>
							<el-option label="中左" value="center"></el-option>
							<el-option
								label="中右"
								value="center_right"
							></el-option>
							<el-option label="右" value="right"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="编号" prop="numbered">
						<el-input
							v-model.number="editform.numbered"
							:disabled="editdisabled"
						></el-input>
					</el-form-item>
				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editClose">取 消</el-button>
				<el-button
					type="primary"
					@click="
						editsubCard(
							editform.name,
							editform.line,
							editform.column,
							editform.numbered,
							editform.seats
						)
					"
					>确 定</el-button
				>
			</span>
		</el-dialog>
		<!-- 修改座位弹窗 -->
		<el-dialog
			title="修改座位信息"
			:visible.sync="centerDialogVisibles"
			:close-on-click-modal="false"
			width="40%"
			left
		>
			<el-form
				ref="formkk"
				:model="udev_seat"
				label-width="110px"
				:rules="rules"
			>
				<el-form-item label="座位数" prop="column">
					<el-input
						v-model="udev_seat.column"
						autocomplete="off"
					></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisibles = false"
					>取 消</el-button
				>
				<el-button type="primary" @click="xsubmit">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 修改排弹窗 -->
		<el-dialog
			title="修改排信息"
			:visible.sync="rowdilog"
			:close-on-click-modal="false"
			width="40%"
			left
		>
			<el-form :model="udev_seat" label-width="110px" :rules="rules">
				<el-form-item label="排信息" prop="row">
					<el-input
						v-model="udev_seat.row"
						autocomplete="off"
					></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="rowdilog = false">取 消</el-button>
				<el-button type="primary" @click="rowsubmit">确 定</el-button>
			</span>
		</el-dialog>
		<!--添加标记颜色  -->
		<el-dialog
			title="添加标记颜色"
			:visible.sync="dialogVisibless"
			width="30%"
			:close-on-click-modal="false"
		>
			<el-input
				v-model="tag_text"
				placeholder="请输入标记内容"
				style="width: 80%"
			></el-input>
			<el-color-picker
				v-model="tag_color"
				style="margin-left: 5px; vertical-align: middle"
				size="medium"
			></el-color-picker>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibless = false">取 消</el-button>
				<el-button type="primary" @click="bjbiaoji">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 删除标记颜色 -->
		<el-dialog
			title="删除标记颜色"
			:visible.sync="removebiaoji"
			width="30%"
			:close-on-click-modal="false"
		>
			<el-select
				v-model="removetag_text"
				placeholder="请选择标记颜色"
				size="small"
				style="margin-left: 10px; margin-right: 10px; width: 100%"
				clearable
			>
				<el-option
					v-for="(item, i) in options"
					:key="i"
					:label="item.label"
					:value="item.value"
				>
					<span style="float: left">{{ item.label }}</span>
					<span
						style="float: right; font-size: 13px"
						:style="{ color: item.value }"
						>{{ item.value }}</span
					>
				</el-option>
			</el-select>
			<span
				style="font-size: 12px;
					margin-left: 15px;
					margin-top: 10px;
					display: block;
					color: red;
				}"
			>提示:请删除未使用标色...</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="removebiaoji = false">取 消</el-button>
				<el-button type="primary" @click="removebiaojis"
					>确 定</el-button
				>
			</span>
		</el-dialog>
		<!-- 新建用户 -->
		<el-dialog
			title="新建用户"
			:visible.sync="dialognewuser"
			width="30%"
			:before-close="closeuserdialog"
			:close-on-click-modal="false"
		>
			<el-form ref="newusers" label-width="80px" :model="user">
				<el-form-item
					label="用户名"
					prop="name"
					:rules="[
						{
							required: true,
							message: '请输入用户名',
							trigger: 'blur',
						},
					]"
				>
					<el-input
						v-model="user.name"
						placeholder="请输入用户名"
					></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone">
					<el-input
						v-model="user.phone"
						placeholder="请输入手机号"
					></el-input>
				</el-form-item>
				<el-form-item label="职称" prop="job">
					<el-input
						v-model="user.job"
						placeholder="请输入职称"
					></el-input>
				</el-form-item>
				<el-form-item label="部门" prop="dep">
					<el-input
						v-model="user.dep"
						placeholder="请输入部门"
					></el-input>
				</el-form-item>
				<el-form-item label="机构" prop="team">
					<el-input
						v-model="user.team"
						placeholder="请输入机构"
					></el-input>
				</el-form-item>
				<el-form-item label="签到编码" prop="sign_code">
					<el-input
						v-model="user.sign_code"
						placeholder="请输入签到编码"
					></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeuserdialog">取 消</el-button>
				<el-button type="primary" @click="submitusrdialog"
					>确 定</el-button
				>
			</span>
		</el-dialog>
		<!-- 导入 -->
		<el-dialog
			title="导入方式"
			:visible.sync="daorufs"
			width="30%"
			:close-on-click-modal="false"
		>
			<el-radio v-model="radios" label="1">追加用户信息</el-radio>
			<el-radio v-model="radios" label="0">覆盖用户信息</el-radio>
			<span slot="footer" class="dialog-footer">
				<el-button @click="daorufs = false">取 消</el-button>
				<el-button type="primary" @click="daorufss">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 设置弹窗 -->
		<el-dialog
			title="设置"
			:visible.sync="dialogset"
			width="30%"
			:close-on-click-modal="false"
		>
			<span>座位提示内容：</span>
			<el-input
				v-model="isset_text"
				placeholder="请输入提示内容 "
				style="width: 70%"
			></el-input>
			<br />
			<span>座位查询时间：</span>
			<el-date-picker
				v-model="zuotime"
				type="datetime"
				value-format="timestamp"
				placeholder="选择座位查询时间"
				style="margin-top: 10px"
			></el-date-picker>
			<div style="margin-top: 10px">
				<span><i style="opacity: 0">隐藏</i>查询座位：</span>
				<el-radio v-model="is_open" label="1" border size="medium"
					>开启</el-radio
				>
				<el-radio v-model="is_open" label="0" border size="medium"
					>关闭</el-radio
				>
				<p style="font-size: 12px; color: #606266; padding: 0px 95px">
					开启后前端显示查询座位入口,关闭则隐藏。
				</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogset = false">取 消</el-button>
				<el-button type="primary" @click="isSetok">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 发送座位信息 -->
		<el-dialog
			title="发送座位信息"
			:visible.sync="sendMsgStatus"
			width="30%"
			:close-on-click-modal="false"
		>
			<span>发送时间：</span>
			<el-date-picker
				v-model="senMsgTime"
				type="datetime"
				value-format="timestamp"
				placeholder="选择发送时间"
				style="margin-top: 10px"
			></el-date-picker>
			<p
				style="font-size: 12px; color: #606266; padding: 0px 0 0 70px"
				v-if="msgSet.type == 2"
			>
				请在座位信息确定后设置短信发送时间，避免座位信息发送错误！（不选时间为立即发送）
			</p>
			<p
				style="font-size: 12px; color: #606266; padding: 0px 0 0 70px"
				v-if="msgSet.type == 0"
			>
				座位信息已发送
			</p>
			<p
				style="font-size: 12px; color: #606266; padding: 0px 0 0 70px"
				v-if="msgSet.type == 1"
			>
				座位信息已设置发送时间：{{ msgSet.time | dateformat }}
			</p>
			<span slot="footer" class="dialog-footer">
				<el-button @click="sendMsgStatus = false">取 消</el-button>
				<el-button type="primary" @click="sendMessage">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import html2canvas from "html2canvas";
import VueDragResize from "vue-drag-resize";
import onResize from "resize-event"

export default {
	name: "Zuowei",
	components: {
		VueDragResize
	},
	data() {
		/* 特殊字符验证 */
		var validateInput = (rule, value, callback) => {
			if (!this.checkSpecialKey(value)) {
				callback(new Error("不能含有特殊字符！！"));
			} else {
				callback();
			}
		};
		return {
			on_fullscreen: false,
			/* 是否排座位 */
			is_open: "1",
			/* 禁用,标色,占座 */
			standard: 0,
			/* 设置 */
			isset_text: "",
			dialogset: false,
			zuotime: "",
			/* 导入方式 */
			daorufs: false,
			radios: "",
			/* 未排数 */
			notarranged: 0,
			/* 全部座位数 */
			scheduled: 0,
			/* 折叠面板*/
			activeNames: ["3"],
			/* 修改排信息 */
			ind: "",
			/* 修改排 */
			rowdilog: false,
			/* 导入url */
			file_url: "",
			/* 新建用户 */
			dialognewuser: false,
			user: {
				name: "",
				phone: "",
				dep: "",
				job: "",
				team: "",
				sign_code: "",
			},
			/* 导出类型 */
			typedaochu: [
				{
					label: "列表",
					value: "0",
				},
				{
					label: "座位图",
					value: "1",
				},
				{
					label: "未报名用户列表",
					value: "3",
				},
			],
			typeval: "",
			/* 下拉标色 */
			options: [],
			values: "",
			/* 删除标记 */
			removebiaoji: false,
			removetag_text: "",
			/* 标记内容 */
			tag_text: "",
			/*标记颜色 */
			tag_color: "",
			/* 添加标色弹窗 */
			dialogVisibless: false,
			/* 座位弹窗变量 */
			centerDialogVisible: false,
			/* 编辑座位 */
			editcenterDialogVisible: false,
			/* 修改座位信息变量 */
			centerDialogVisibles: false,
			/* 座位弹窗绑定数据 */
			form: {
				name: "",
				line: "",
				column: "",
				numbered: "",
				seat: "",
			},
			editdisabled: true,
			/* 编辑弹窗绑定数据 */
			editform: {
				name: "",
				line: "",
				column: "",
				numbered: "",
				seats: "",
			},
			/* 弹窗表格验证 */
			rules: {
				name: [
					{
						required: true,
						message: "区域名不能为空",
						trigger: "blur",
					},
				],
				seat: [
					{
						required: true,
						message: "请选择座位起始位置",
						trigger: "blur",
					},
				],
				column: [{ validator: validateInput, trigger: "change" }],
				row: [{ validator: validateInput, trigger: "change" }],
			},
			/* 禁用编号 */
			disabled: false,
			/* 卡片list */
			cards: [],
			/* 座位号 */
			conferenceSeats: [],
			/* 选座位的客户 */
			client_list: [],
			/* 选中的座位 */
			/* 行 */
			line: "",
			/* 列 */
			column: "",
			/* 编号 */
			numbered: "",
			/* 座位号 */
			seat: "",
			/* 排号 */
			row: "",
			oldarr: [],
			timer: null,
			/* 座位用户信息 */
			zuomember: "",
			/* 修改的座位表单 */
			udev_seat: {
				column: "",
				row: "",
			},
			//发送座位信息
			sendMsgStatus: false,
			senMsgTime: "",
			msgSet: {}, //发送座位信息设置


			dragable: false,
			dragable_user_box_max_height: 300,
			main_panel_box_width: 0,

			drag_position: {
				width: 0,
				height: 0,
				top: 0,
				left: 0,
			},

			// restaurants: [],

			title_bar_drag_model: '',

			title_bar_filter_index: 0,
			title_bar_options: [
				{
					value: 0,
					label: '全部'
				},
				{
					value: 1,
					label: '已设置'
				},
				{
					value: 2,
					label: '未设置'
				},
			],

			active_seat_id: null,
			active_user_id: null
		};
	},
	computed: {
		filtered_user_list: function(){
			let list = this.client_list, keywords = this.title_bar_drag_model
			list = this.client_list.filter(i => {
				if(this.title_bar_filter_index == 0){
					return true
				} else if (this.title_bar_filter_index == 1) {
					return i.seat_status == 1
				} else if (this.title_bar_filter_index == 2){
					return i.seat_status == 2
				}
			})
			return list.filter(this.createFilter(keywords))
		}
	},
	created() {
		this.id = this.$route.query.id;
		this.order_users();
		this.getlist();
	},
	mounted() {

		var _this = this;
		_this.timer = setInterval(() => {
			_this.remember();
		}, 300000);


		const el = $('#boxs')[0]
		onResize(el, () => {
			if(el.offsetHeight > 10){
				this.dragable_user_box_max_height = this.$refs.qrCodeDiv.offsetHeight
			}
		})
	},
	methods: {
		handleSetSomeSize(){
			this.main_panel_box_width = $('.app .main-panel .box').css('width').replace('px', '')
		},
		//获取发送座位信息
		getMessage() {
			var _this = this;
			var url = "/ac1/conference/seat/detail";
			var params = {
				id: _this.id,
			};
			_this.$get(url, params).then((res) => {
				console.log(res);
				if (res.code == 1) {
					_this.msgSet = res.posts.msg;
				}
			});
		},
		//发送座位信息
		sendMessage() {
			var _this = this;
			if (_this.sendMsgStatus) {
				let url = _this.APIurl.API.api.sendMsg;
				if (_this.senMsgTime != "") {
					var times = new Date(_this.senMsgTime).getTime() / 1000;
				} else {
					var times = "";
				}
				let params = {
					time: times,
					id: _this.id,
				};
				_this.$post(url, params).then((res) => {
					if (res.code == 1) {
						_this.$message({
							message: "设置发送座位信息成功",
							type: "success",
							duration: 1000,
						});
						_this.sendMsgStatus = false;
						_this.getMessage();
					} else {
						_this.$message({
							message: res.msg,
							type: "warning",
						});
					}
				});
			} else {
				_this.sendMsgStatus = true;
			}
		},
		/* 设置 */
		isSet() {
			var _this = this;
			_this.dialogset = true;
		},
		isSetok() {
			var _this = this;
			var url = "/ac1/conference/seat/saveTips";
			var params = {
				id: _this.id,
				tips: _this.isset_text,
				start_time: _this.zuotime / 1000,
				is_open: _this.is_open,
			};
			_this.$post(url, params).then((res) => {
				if (res.code == 1) {
					_this.$message({
						message: "保存成功",
						type: "success",
						duration: 1000,
					});
					_this.dialogset = false;
				}
			});
		},
		/* 移除文件 */
		removefile() {
			var _this = this;
			_this.file_url = "";
		},
		/* 确定导入方式提交 */
		daorufss() {
			var _this = this;
			var url = "/ac1/conference/seat/importExcelList";
			var params = {
				id: _this.id,
				file_url: _this.file_url,
				type: _this.typeval,
				is_add: _this.radios,
			};
			_this.$post(url, params).then((res) => {
				if (res.code == 1) {
					_this.$message({
						message: "成功",
						type: "success",
						duration: 1000,
					});
					_this.getlist();
					_this.order_users();
					_this.file_url = "";
					_this.daorufs = false;
				} else {
					_this.$message({
						message: res.msg,
						type: "warning",
						duration: 3000,
					});
				}
			});
		},
		/* 删除标记颜色 */
		removebiaojis() {
			var _this = this;
			var thistext = _this.removetag_text;
			var opt = _this.options;
			var zuolis = _this.conferenceSeats;
			var arr = [];
			for (let i = 0; i < zuolis.length; i++) {
				const izuolis = zuolis[i].array_seat;
				for (let j = 0; j < izuolis.length; j++) {
					const jizuolists = izuolis[j];
					for (let m = 0; m < jizuolists.length; m++) {
						const mjizuolists = jizuolists[m];
						if (mjizuolists.color != "") {
							arr.push(mjizuolists.color);
						}
					}
				}
			}
			arr = Array.from(new Set(arr));
			if (thistext != "") {
				opt.forEach(function (v, x) {
					if (v.value == thistext && arr.indexOf(v.value) == -1) {
						opt.splice(x, 1);
						_this.$message({
							message: "成功",
							type: "success",
							duration: 1000,
						});
						_this.removetag_text = "";
						_this.removebiaoji = false;
					}
				});
			} else {
				_this.$message({
					message: "内容不能为空",
					type: "warning",
					duration: 1000,
				});
			}
		},
		/* 校验特殊字符 */
		checkSpecialKey(str) {
			var specialKey =
				"[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
			for (var i = 0; i < str.length; i++) {
				if (specialKey.indexOf(str.substr(i, 1)) != -1) {
					return false;
				}
			}
			return true;
		},
		/* 获取已排/全部排数 */
		getpai() {
			var _this = this;
			var yipai = [];
			var weipai = [];
			var jin = [];
			var zuolist = _this.conferenceSeats;
			for (let i = 0; i < zuolist.length; i++) {
				var yu = zuolist[i].array_seat;
				for (let j = 0; j < yu.length; j++) {
					var onezuo = yu[j];
					for (let l = 0; l < onezuo.length; l++) {
						var a = onezuo[l];
						weipai.push(a);
						if (a.member.member != "") {
							yipai.push(a);
						} else if (a.checkDisabledState == true) {
							jin.push(a);
						}
					}
				}
			}
			_this.notarranged = weipai.length - jin.length;
			_this.scheduled = yipai.length;
		},
		/* 提醒保存 */
		remember() {
			var _this = this;
			_this.$notify.info({
				title: "提示！",
				message: "已有5分钟没有保存数据了,以免丢失数据请先保存。",
				duration: 8000,
			});
		},
		/* 提交修改排信息*/
		rowsubmit() {
			var _this = this;
			var zuolists = _this.conferenceSeats;

			if (_this.udev_seat.row == "") {
				_this.$message({
					message: "内容不能为空",
					type: "warning",
					duration: 1000,
				});
			} else {
				for (let i = 0; i < zuolists.length; i++) {
					if (zuolists[i].numbered == _this.numbered) {
						const izuolists = zuolists[i].array_seat;
						for (let j = 0; j < izuolists.length; j++) {
							const jizuolists = izuolists[j];
							for (let m = 0; m < jizuolists.length; m++) {
								if (jizuolists[m].row == _this.row) {
									jizuolists[m].row = _this.udev_seat.row;
								}
							}
						}
					}
				}
				_this.ind = "";
				(_this.line = ""),
					(_this.column = ""),
					(_this.numbered = ""),
					(_this.seat = ""),
					(_this.row = ""),
					(_this.udev_seat.row = "");
				_this.rowdilog = false;
			}
		},
		/* 修改排信息*/
		change_rows(rows) {
			var _this = this;
			_this.udev_seat.row = rows;
			if (_this.line == "") {
				_this.$message({
					message: "请选择座位",
					type: "warning",
					duration: 1000,
				});
			} else {
				_this.rowdilog = true;
			}
		},
		/* 自动排座位号 */
		seating(n, seat) {
			var _this = this;
			_this
				.$confirm("自动排号会覆盖掉您排好的座位号, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
				.then(() => {
					var as = _this.conferenceSeats[n].array_seat;
					_this.zidongpai(as, seat);
				})
				.catch(() => {
					_this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		zidongpai(as, seat) {
			var _this = this;
			var arrkk = [];
			for (let i = 0; i < as.length; i++) {
				var numbers = 0;
				for (let h = 0; h < as[i].length; h++) {
					if (!as[i][h].checkDisabledState) {
						numbers += 1;
					}
				}
				arrkk.push(numbers);
			}

			var seatsbox = [];
			if (seat == "center") {
				for (var p = 0; p < arrkk.length; p++) {
					seatsbox.push(_this.xcenter(arrkk[p]));
				}
			} else if (seat == "center_right") {
				for (var p = 0; p < arrkk.length; p++) {
					seatsbox.push(_this.xcenter_right(arrkk[p]));
				}
			} else if (seat == "left") {
				for (var p = 0; p < arrkk.length; p++) {
					seatsbox.push(_this.xleft(arrkk[p]));
				}
			} else if (seat == "right") {
				for (var p = 0; p < arrkk.length; p++) {
					seatsbox.push(_this.xright(arrkk[p]));
				}
			}

			for (let i = 0; i < as.length; i++) {
				var onNum = 0;
				for (let h = 0; h < as[i].length; h++) {
					if (!as[i][h].checkDisabledState) {
						as[i][h].seats = seatsbox[i][onNum] + "座";
						onNum += 1;
					}
				}
			}
			_this.$message({
				message: "排号成功",
				type: "success",
				duration: 1000,
			});
		},
		/* 打开编辑区域*/
		editCard(name, line, column, numbered, seats) {
			var _this = this;
			_this.editform.name = name;
			_this.editform.numbered = numbered;
			_this.editform.seats = seats;
			_this.editcenterDialogVisible = true;
		},
		/* 关闭编辑区域 */
		editClose() {
			var _this = this;
			_this.editform.name = "";
			_this.editform.numbered = "";
			_this.editform.seats = "";
			_this.editcenterDialogVisible = false;
		},
		/* 提交编辑区域 */
		editsubCard(name, line, column, numbered, seats) {
			var _this = this;
			var list = _this.cards;
			var zuolist = _this.conferenceSeats;
			for (let i = 0; i < zuolist.length; i++) {
				if (zuolist[i].numbered == numbered) {
					zuolist[i].position = seats;
					list[i].seat = seats;
				}
			}
			console.log(zuolist);
			_this.editcenterDialogVisible = false;
		},
		/* 下载座位模板 */
		download() {
			var _this = this;
			window.location.href =
				"/ac1/conference/seat/excelTmp?member_token=" +
				_this.$cookies.get("member_token") +
				"&conferenceId=" +
				sessionStorage.getItem("conferenceId");
		},
		/* 初始化获取座位信息 */
		getlist() {
			var _this = this;
			var url = "/ac1/conference/seat/detail";
			var params = {
				id: _this.id,
			};
			_this.$get(url, params).then((res) => {
				// console.log(res);
				if (res.code == 1) {
					// console.log(res.posts.start_time);
					if (res.posts == "") {
						console.log("无数据");
					} else {
						_this.isset_text = res.posts.tips;
						if (res.posts.start_time == undefined) {
							_this.zuotime = "";
							_this.is_open = "1";
						} else {
							_this.zuotime = res.posts.start_time * 1000;
							_this.is_open = String(res.posts.is_open);
						}

						var lists = res.posts.seat;
						var arr = [];
						for (let i = 0; i < lists.length; i++) {
							var obj = {
								name: lists[i].area,
								line: lists[i].line,
								column: lists[i].column,
								numbered: lists[i].numbered,
								seat: lists[i].position,
							};
							arr.push(obj);
						}
						_this.conferenceSeats = lists;
						if (lists[0].tag_color != "") {
							_this.options = lists[0].tag_color;
						}
						_this.cards = arr;
						_this.getpai();

						_this.msgSet = res.posts.msg;
					}
				}
			});
		},
		/* 返回会议 */
		back() {
			this.$router.push({
				path: "/admin/MyMeeting",
				query: {
					editId: this.$route.query.id,
					cur: this.$route.query.cur,
					tab_name: this.$route.query.tab_name,
				},
			});
		},
		/*打开新建区域弹窗 */
		addCard() {
			var _this = this;
			_this.cardid = 1;
			_this.disabled = false;
			_this.centerDialogVisible = true;
		},
		/* 关闭新建区域弹窗 */
		close() {
			var _this = this;
			(_this.form = {
				name: "",
				line: "",
				column: "",
				numbered: "",
			}),
				_this.$refs.form.resetFields();
			_this.centerDialogVisible = false;
		},
		/*提交区域 */
		subCard() {
			var _this = this;
			_this.$refs["form"].validate((valid) => {
				if (valid) {
					var result = _this.cards.some(function (item) {
						if (item.numbered == Number(_this.form.numbered)) {
							return true;
						} else {
							return false;
						}
					});
					if (result) {
						_this.$message({
							message: "编号相同",
							type: "warning",
							duration: 1000,
						});
					} else {
						var obj = {};
						obj = {
							name: _this.form.name,
							line: _this.form.line,
							column: _this.form.column,
							numbered: _this.form.numbered,
							seat: _this.form.seat,
						};
						/* 设置座位 */
						_this.numberzuo(
							obj.name,
							obj.line,
							obj.column,
							obj.numbered,
							obj.seat
						);
						_this.cards.push(obj);
						(_this.form = {
							name: "",
							line: "",
							column: "",
							numbered: "",
							seat: "",
						}),
							_this.getpai();
						_this.centerDialogVisible = false;
						_this.$refs.form.resetFields();
					}
				}
			});
		},
		/* 删除card */
		remove(id) {
			var _this = this;
			var url = "/ac1/conference/seat/save";
			var params = {
				id: _this.id,
				data: _this.conferenceSeats,
			};
			_this
				.$confirm("删除区域会清除本区域的已排座位，是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
				.then(() => {
					for (let j = 0; j < _this.conferenceSeats.length; j++) {
						if (_this.conferenceSeats[j].numbered == id) {
							_this.conferenceSeats.splice(j, 1);
							_this.cards.splice(j, 1);
						}
					}
					/* 删除后重新请求座位数据 */
					_this.$post(url, params).then((res) => {
						if (res.code == 1) {
							_this.$message({
								type: "success",
								message: "删除成功!",
								duration: 1000,
							});
							_this.getlist();
							/* 请求订单完成用户的数据 */
							_this.order_users();
						} else {
							_this.$message({
								message: res.msg,
								type: "warning",
							});
						}
					});
				})
				.catch(() => {
					_this.$message({
						type: "info",
						message: "已取消删除",
						duration: 1000,
					});
				});
		},
		/* 设置区域座位 */
		numberzuo(name, line, column, numbered, seat) {
			var _this = this;
			var arr = [];
			var ok = {};
			for (let i = 1; i <= line; i++) {
				var obj = {};
				var huan = [];
				for (let j = 1; j <= column; j++) {
					obj = {
						line: i,
						column: j,
						row: i + "排",
						seats: "" + "座",
						member: {
							member: "",
						},
						checkDisabledState: false,
						seat_t: false,
						color: "",
					};
					huan.push(obj);
				}
				arr.push(huan);
			}
			ok = {
				numbered: numbered,
				tag_color: _this.options,
				column: column,
				line: line,
				area: name,
				position: seat,
				array_seat: arr,
			};
			_this.zidongpai(ok.array_seat, ok.position);
			_this.conferenceSeats.push(ok);
		},
		/* 客户 */
		order_users() {
			var _this = this;
			var url = "/ac1/conference/seat/memberLisrt";
			var params = {
				id: _this.id,
			};
			_this.$get(url, params).then((res) => {
				console.log(res);
				if (res.code == 1) {
					_this.client_list = res.posts.map(i => ({...i, value: i.name, seat_status: i.membercheck ? 1 : 2}));

					this.handleSetSomeSize()
				} else {
					console.log("无用户信息");
				}
			});
		},
		/* 新建用户 */
		newuser() {
			var _this = this;
			_this.dialognewuser = true;
		},
		/* 关闭新建用户 */
		closeuserdialog() {
			var _this = this;
			(_this.user = {
				name: "",
				phone: "",
				dep: "",
				job: "",
				team: "",
				sign_code: "",
			}),
				_this.$refs.newusers.resetFields();
			_this.dialognewuser = false;
		},
		/* 提交新建用户 */
		submitusrdialog() {
			var _this = this;
			var url = "/ac1/conference/seat/addMember";
			var params = {
				id: _this.id,
				name: _this.user.name,
				tel: _this.user.phone,
				dep: _this.user.dep,
				job: _this.user.job,
				team: _this.user.team,
				sign_code: _this.user.sign_code,
			};
			_this.$post(url, params).then((res) => {
				if (res.code == 0) {
					this.$message({
						type: "info",
						message: res.msg,
					});
				} else if (res.code == 1) {
					_this.order_users();
					(_this.user = {
						name: "",
						phone: "",
						dep: "",
						job: "",
						team: "",
						sign_code: "",
					}),
						_this.$refs.newusers.resetFields();
					_this.dialognewuser = false;
				}
			});
		},
		/* 选择座位 */
		currentInfo(i, j, k, seat, row, item) {

			if(this.active_seat_id == 'id+' + k + i + j){
				this.active_seat_id = null
			} else {
				this.active_seat_id = 'id+' + k + i + j
			}

			if(item.member.member.id){
				this.active_user_id = item.member.member.id
				const list = $('.dragable_user_box .content-container .box_wrapper .userbt')
				for (const key in list) {
					if (Object.hasOwnProperty.call(list, key)) {
						const el = list[key];
						if(Number($(el).attr('id')) == this.active_user_id){
							this.viewit_and_shake(el)
							break
						}
					}
				}
			}


			var _this = this;
			var lists = _this.conferenceSeats;
			var order_userlist = _this.client_list;
			var onepeople = "";

			if (_this.standard == 1) {
				for (let a = 0; a < lists.length; a++) {
					const aset = lists[a].numbered;
					if (aset == k) {
						const asets = lists[a].array_seat;
						for (let b = 0; b < asets.length; b++) {
							const hang = asets[b];
							for (let c = 0; c < hang.length; c++) {
								const cone = hang[c];
								if (cone.line == i && cone.column == j) {
									if (
										cone.member.member == "" &&
										cone.seat_t == false &&
										cone.color == ""
									) {
										cone.checkDisabledState =
											!cone.checkDisabledState;
										_this.getpai();
									} else {
										_this.$message({
											message: "不可禁用此座位",
											type: "warning",
											duration: 1000,
										});
									}
								}
							}
						}
					}
				}
			} else if (_this.standard == 2) {
				for (let a = 0; a < lists.length; a++) {
					const aset = lists[a].numbered;
					if (aset == k) {
						const asets = lists[a].array_seat;
						for (let b = 0; b < asets.length; b++) {
							const hang = asets[b];
							for (let c = 0; c < hang.length; c++) {
								const cone = hang[c];
								if (cone.line == i && cone.column == j) {
									if (
										cone.member.member == "" &&
										cone.checkDisabledState == false &&
										cone.color == ""
									) {
										cone.seat_t = !cone.seat_t;
									} else {
										_this.$message({
											message: "不可占用此座位",
											type: "warning",
											duration: 1000,
										});
									}
								}
							}
						}
					}
				}
			} else if (_this.standard == 3) {
				for (let a = 0; a < lists.length; a++) {
					const aset = lists[a].numbered;
					if (aset == k) {
						const asets = lists[a].array_seat;
						for (let b = 0; b < asets.length; b++) {
							const hang = asets[b];
							for (let c = 0; c < hang.length; c++) {
								const cone = hang[c];
								if (cone.line == i && cone.column == j) {
									if (
										cone.checkDisabledState == false &&
										cone.seat_t == false &&
										cone.color == ""
									) {
										if (_this.values == "") {
											_this.$message({
												message: "请选择标色",
												type: "warning",
												duration: 1000,
											});
										} else {
											cone.color = _this.values;
										}
									} else if (
										cone.checkDisabledState == false &&
										cone.seat_t == false &&
										cone.color != ""
									) {
										cone.color = "";
									} else {
										_this.$message({
											message: "不可占用此座位",
											type: "warning",
											duration: 1000,
										});
									}
								}
							}
						}
					}
				}
			} else if (_this.standard == 4) {
				for (let a = 0; a < lists.length; a++) {
					const aset = lists[a].numbered;
					if (aset == k) {
						const asets = lists[a].array_seat;
						for (let b = 0; b < asets.length; b++) {
							const hang = asets[b];
							for (let c = 0; c < hang.length; c++) {
								const cone = hang[c];
								if (cone.line == i && cone.column == j) {
									if (cone.member.member != "") {
										onepeople = cone.member.member.id;
										cone.member.member = "";
										for (
											let d = 0;
											d < order_userlist.length;
											d++
										) {
											if (
												order_userlist[d].id ==
												onepeople
											) {
												order_userlist[
													d
												].membercheck = false;
												order_userlist[d].line = "";
												order_userlist[d].column = "";
												order_userlist[d].row = "";
												order_userlist[d].seats = "";
												order_userlist[d].numbered = "";
												order_userlist[d].membercheck = false;
												order_userlist[d].seat_status = 2;
											}
										}
										_this.getpai();
									} else {
										_this.$message({
											message: "无用户",
											type: "warning",
											duration: 1000,
										});
									}
								}
							}
						}
					}
				}
			} else {
				if (_this.ind == "" || _this.ind != "id+" + k + i + j) {
					_this.ind = "id+" + k + i + j;
					_this.line = i;
					_this.column = j;
					_this.numbered = k;
					_this.seat = seat;
					_this.row = row;
				} else if (_this.ind == "id+" + k + i + j) {
					_this.ind = "";
					_this.line = "";
					_this.column = "";
					_this.numbered = "";
					_this.seat = "";
					_this.row = "";
				}
				for (let e = 0; e < lists.length; e++) {
					if (lists[e].numbered == k) {
						var array_seat = lists[e].array_seat;
						for (let r = 0; r < array_seat.length; r++) {
							var mp = array_seat[r];
							for (let m = 0; m < mp.length; m++) {
								if (mp[m].line == i && mp[m].column == j) {
									if (mp[m].member.member != "") {
										_this.zuomember = mp[m].member.member;
									} else {
										_this.zuomember = "";
									}
								}
							}
						}
					}
				}
				if (_this.zuomember == "") {
					console.log("无信息");
				} else {
					_this.$notify({
						title: "座位用户信息",
						dangerouslyUseHTMLString: true,
						message: `<p>姓名：${_this.zuomember.name}</p>
							<p>电话：${_this.zuomember.tel ? _this.zuomember.tel : ""}</p>
							<p>职称：${_this.zuomember.job ? _this.zuomember.job : ""}</p>
							<p>部门：${_this.zuomember.dep ? _this.zuomember.dep : ""}</p>
							<p>机构：${_this.zuomember.team ? _this.zuomember.team : ""}</p>
							<p>区域编号：${k}</p>
							<p>座位信息：${row}${seat}</p>
						`,
						position: "top-left",
					});
				}
			}
		},
		/* 选择座位起始位置中左时 */
		xcenter(column) {
			var _this = this;
			var a = [];
			var b = [];
			var c = [];
			var arr = column;
			let unseat = true;
			for (let i = 1; i <= arr; i++) {
				if (unseat) {
					a.push(i);
					unseat = false;
				} else {
					b.push(i);
					unseat = true;
				}
			}
			b = b.reverse();
			c = b.concat(a);
			return c;
		},
		/* 选择座位起始位置中右时 */
		xcenter_right(column) {
			var _this = this;
			var a = [];
			var b = [];
			var c = [];
			var arr = column;
			let unseats = true;
			for (let i = 1; i <= arr; i++) {
				if (unseats) {
					a.push(i);
					unseats = false;
				} else {
					b.push(i);
					unseats = true;
				}
			}
			a = a.reverse();
			c = a.concat(b);
			return c;
		},
		/*选择座位起始位置左时  */
		xleft(column) {
			var a = column;
			var arr = [];
			for (let i = 1; i <= a; i++) {
				arr.push(i);
			}
			return arr;
		},
		/*选择座位起始位置右时  */
		xright(column) {
			var a = column;
			var arr = [];
			for (let i = 1; i <= a; i++) {
				arr.push(i);
			}
			arr = arr.reverse();
			return arr;
		},
		/* 禁用 */
		jy() {
			var _this = this;
			_this.standard = 1;
			if (_this.ind != "") {
				_this.ind = "";
				_this.line = "";
				_this.column = "";
				_this.numbered = "";
				_this.seat = "";
				_this.row = "";
			}
		},
		/* 占座 */
		ckSeat() {
			var _this = this;
			_this.standard = 2;
			if (_this.ind != "") {
				_this.ind = "";
				_this.line = "";
				_this.column = "";
				_this.numbered = "";
				_this.seat = "";
				_this.row = "";
			}
		},
		/* 无状态 */
		nocheck() {
			var _this = this;
			_this.standard = 0;
		},
		/* 用户点击选座 */
		clickpeople(xb) {

			this.active_user_id = xb
			const list = $('.seat_box .waibian .boxs').find('.xuan')
			for (const key in list) {
				if (Object.hasOwnProperty.call(list, key)) {
					// console.log('key', key, list[key])
					const el = list[key];
					if(Number($(el).attr('user_id')) == this.active_user_id){
						this.viewit_and_shake(el)
						break
					}
				}
			}
			// this.viewit_and_shake(el)

			var _this = this;
			var lists = _this.conferenceSeats;
			var onemation = "";
			if (
				_this.line == "" ||
				_this.column == "" ||
				_this.numbered == ""
			) {
				_this.$message({
					message: "请选择座位",
					type: "warning",
					duration: 1000,
				});
			} else {
				/* 选中的客户信息 */
				for (let f = 0; f < _this.client_list.length; f++) {
					const oneuser = _this.client_list[f];
					if (oneuser.id == xb) {
						onemation = oneuser;
					}
				}
				if (onemation.membercheck == true) {
					_this.$message({
						message: "已经排座",
						type: "warning",
						duration: 1000,
					});
				} else {
					this.active_seat_id = null

					for (let i = 0; i < lists.length; i++) {
						if (lists[i].numbered == _this.numbered) {
							var array_seat = lists[i].array_seat;
							for (let j = 0; j < array_seat.length; j++) {
								var wei = array_seat[j];
								for (let m = 0; m < wei.length; m++) {
									if (
										wei[m].column == _this.column &&
										wei[m].line == _this.line
									) {
										if (
											wei[m].member.member !== "" ||
											wei[m].checkDisabledState == true ||
											wei[m].seat_t == true
										) {
											_this.$message({
												message: "请选择可选座位",
												type: "warning",
												duration: 1000,
											});
										} else {
											wei[m].member.member = onemation;
											wei[m].member.member.line =
												_this.line;
											wei[m].member.member.column =
												_this.column;
											wei[m].member.member.row =
												_this.row;
											wei[m].member.member.seats =
												_this.seat;
											wei[
												m
											].member.member.membercheck = true;
											onemation.membercheck = true;
											var url =
												"/ac1/conference/seat/save";
											var arrs = JSON.stringify(
												_this.conferenceSeats
											);
											var params = {
												id: _this.id,
												data: arrs,
											};
											_this
												.$post(url, params)
												.then((res) => {
													if (res.code == 1) {
														_this.order_users();
														_this.getlist();
													}
												});
											_this.ind =
												"id+" +
												lists[i].numbered +
												wei[m + 1].line +
												wei[m + 1].column;
											_this.line = wei[m + 1].line;
											_this.column = wei[m + 1].column;
											_this.numbered = lists[i].numbered;
											_this.seat = wei[m + 1].seats;
											_this.row = wei[m + 1].row;
											_this.getpai();
											break;
										}
									}
								}
							}
						}
					}
				}
			}
		},
		/* 清除单个用户的修改 */
		removekehu() {
			var _this = this;
			_this.standard = 4;
			if (_this.ind != "") {
				_this.ind = "";
				_this.line = "";
				_this.column = "";
				_this.numbered = "";
				_this.seat = "";
				_this.row = "";
			}
		},
		/* 清除所有的排座位 */
		removeall() {
			var _this = this;
			var order_userlist = _this.client_list;
			var lists = _this.conferenceSeats;
			_this
				.$confirm("是否要清除所有选座?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
				.then(() => {
					for (let i = 0; i < lists.length; i++) {
						var array_seat = lists[i].array_seat;
						for (let j = 0; j < array_seat.length; j++) {
							var wei = array_seat[j];
							for (let m = 0; m < wei.length; m++) {
								if (wei[m].member.member != "") {
									wei[m].member.member = "";
								}
							}
						}
					}
					for (let n = 0; n < order_userlist.length; n++) {
						order_userlist[n].membercheck = false;
						order_userlist[n].line = "";
						order_userlist[n].column = "";
						order_userlist[n].row = "";
						order_userlist[n].seats = "";
						order_userlist[n].numbered = "";
					}
					this.$message({
						type: "success",
						message: "清除成功",
					});
					_this.getpai();
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		/* 修改座位 */
		modify() {
			var _this = this;
			if (
				_this.line == "" ||
				_this.column == "" ||
				_this.numbered == ""
			) {
				_this.$message({
					message: "请选择座位",
					type: "warning",
					duration: 1000,
				});
			} else {
				_this.centerDialogVisibles = true;
				_this.$set(_this.udev_seat, "column", _this.seat);
			}
		},
		/* 提交修改座位 */
		xsubmit() {
			var _this = this;
			var lists = _this.conferenceSeats;
			for (let i = 0; i < lists.length; i++) {
				if (lists[i].numbered == _this.numbered) {
					var array_seat = lists[i].array_seat;
					for (let j = 0; j < array_seat.length; j++) {
						var wei = array_seat[j];
						for (let m = 0; m < wei.length; m++) {
							if (
								wei[m].column == _this.column &&
								wei[m].line == _this.line
							) {
								var shk = wei[m];
								_this.$set(
									shk,
									"seats",
									_this.udev_seat.column
								);
								_this.$message({
									message: "修改成功",
									type: "success",
									duration: 1000,
								});
								_this.centerDialogVisibles = false;
							}
						}
					}
				}
			}
		},
		/* 标记颜色 */
		tag_colors() {
			var _this = this;
			_this.standard = 3;
			if (_this.ind != "") {
				_this.ind = "";
				_this.line = "";
				_this.column = "";
				_this.numbered = "";
				_this.seat = "";
				_this.row = "";
			}
		},
		/* 添加标记颜色确定 */
		bjbiaoji() {
			var _this = this;
			var obj = {};
			obj = {
				value: _this.tag_color,
				label: _this.tag_text,
			};
			if (obj.label == "" || obj.value == "") {
				_this.$message({
					type: "warning",
					message: "内容/颜色不能为空",
					duration: 1000,
				});
			} else {
				_this.options.push(obj);
				_this.tag_text = "";
				_this.$message({
					type: "success",
					message: "保存成功",
					duration: 1000,
				});
				_this.dialogVisibless = false;
			}
		},
		/* 类型导入 */
		submitUpload() {
			var _this = this;
			var url = "/ac1/conference/seat/importExcelList";
			var params = {
				id: _this.id,
				file_url: _this.file_url,
				type: _this.typeval,
			};
			if (_this.typeval == "") {
				_this.$message({
					type: "warning",
					message: "请选择导入类型",
					duration: 1000,
				});
			} else {
				if (_this.file_url == "") {
					_this.$message({
						type: "warning",
						message: "请选择文件",
						duration: 1000,
					});
				} else {
					if (_this.typeval == 0 || _this.typeval == 3) {
						_this.daorufs = true;
					} else {
						_this
							.$confirm(
								"此操作会覆盖用户信息, 是否继续?",
								"提示",
								{
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning",
								}
							)
							.then(() => {
								_this.$post(url, params).then((res) => {
									if (res.code == 1) {
										_this.$message({
											message: "成功",
											type: "success",
											duration: 1000,
										});
										_this.getlist();
										_this.order_users();
										_this.file_url = "";
									} else {
										_this.$message({
											message: res.msg,
											type: "warning",
											duration: 3000,
										});
									}
								});
							})
							.catch(() => {
								_this.$message({
									type: "info",
									message: "已取消",
								});
							});
					}
				}
			}
		},
		/* 导入成功 */
		fileok(response, file, fileList) {
			var _this = this;

			if (response.code == 1) {
				_this.file_url = response.posts.file_url;
				_this.$message({
					type: "success",
					message: "导入成功",
					duration: 1000,
				});
			} else {
				_this.$message({
					type: "error",
					message: response.msg,
					duration: 1000,
				});
			}
		},
		/* 导入失败 */
		fileno(err, file, fileList) {
			console.log(err);
		},
		/* 导入时超出个数 */
		overflows(files, fileList) {
			var _this = this;
			_this.$message({
				type: "warning",
				message: "超出限制数",
				duration: 1000,
			});
		},
		/* 导出Excil */
		daochuex() {
			var _this = this;
			if (_this.typeval == "") {
				_this.$message({
					type: "warning",
					message: "请选择导出类型",
					duration: 1000,
				});
			} else {
				window.location.href =
					"/ac1/conference/seat/exportExcel?id=" +
					_this.id +
					"&type=" +
					_this.typeval +
					"&member_token=" +
					_this.$cookies.get("member_token") +
					"&conferenceId=" +
					sessionStorage.getItem("conferenceId");
			}
		},
		/* 生成图片 */
		generateimg() {
			var _this = this;
			var line = []; /* 高 */
			var column = []; /* 宽 */
			var a = "";
			var b = "";
			var list = _this.conferenceSeats;
			$(".box").find("li").removeClass("active");
			if (list == "") {
				_this.$message({
					message: "无区域座位",
					type: "warning",
					duration: 1000,
				});
			} else {
				for (let i = 0; i < list.length; i++) {
					column.push(list[i].column);
					line.push(list[i].line);
				}
				if (line.length == 1) {
					a = line[0];
				} else {
					for (let j = 0; j < line.length; j++) {
						a = line[j] + line[j - 1];
					}
				}
				b = Math.max(...column);
				$(".boxs").width(92 * b);
				html2canvas(this.$refs.qrCodeDiv).then((canvas) => {
					const link = document.createElement("a");
					link.href = canvas.toDataURL();
					link.setAttribute("download", "座位图" + ".png");
					link.style.display = "none";
					document.body.appendChild(link);
					link.click();
				});
			}
		},
		/* 批量填入座位 */
		piliang() {
			var _this = this;
			var peopleslist = _this.client_list;
			var zuowelist = _this.conferenceSeats;
			if (zuowelist == "") {
				_this.$message({
					type: "warning",
					message: "无座位信息",
					duration: 1000,
				});
			} else {
				_this
					.$confirm("确定要批量填入, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						_this.ixBatch();
						_this.$message({
							type: "success",
							message: "填入成功",
						});
					})
					.catch(() => {
						_this.$message({
							type: "info",
							message: "已取消填入",
						});
					});
			}
		},
		/* 批量填入函数 */
		ixBatch() {
			var _this = this;
			var peopleslist = _this.client_list;
			var zuowelist = _this.conferenceSeats;
			for (let z = 0; z < peopleslist.length; z++) {
				const ztem = peopleslist[z];
				let membercheck = false;
				if (!ztem.membercheck && !membercheck) {
					for (let i = 0; i < zuowelist.length; i++) {
						const item = zuowelist[i].array_seat;
						if (!membercheck) {
							for (let x = 0; x < item.length; x++) {
								const xtem = item[x];
								if (!membercheck) {
									for (let y = 0; y < xtem.length; y++) {
										const ytem = xtem[y];
										if (
											ytem.member.member === "" &&
											ytem.checkDisabledState !== true &&
											ytem.seat_t !== true &&
											!membercheck
										) {
											ytem.member.member = ztem;
											ytem.member.membercheck = true;
											membercheck = true;
											ztem.membercheck = true;
										}
									}
								}
							}
						}
					}
				}
			}
		},
		/* 保存 */
		save() {
			var _this = this;
			var allcon = _this.conferenceSeats;
			for (let i = 0; i < allcon.length; i++) {
				const iallcon = allcon[i];
				iallcon.tag_color = _this.options;
			}
			var url = "/ac1/conference/seat/save";
			var arrs = JSON.stringify(_this.conferenceSeats);
			var params = {
				id: _this.id,
				data: arrs,
			};
			if (_this.conferenceSeats) {
				this.$confirm("确定要保存吗?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
					.then(() => {
						_this.$post(url, params).then((res) => {
							if (res.code == 1) {
								_this.$message({
									type: "success",
									message: "保存成功",
									duration: 1000,
								});
								_this.getlist();
								_this.order_users();
							} else {
								_this.$message({
									message: res.msg,
									type: "warning",
								});
							}
						});
					})
					.catch(() => {
						_this.$message({
							type: "info",
							message: "已取消",
							duration: 1000,
						});
					});
			} else {
				_this.$message({
					message: "无座位信息",
					type: "warning",
					duration: 1000,
				});
			}
		},
		resize(newRect) {
			this.drag_position.width = newRect.width;
			this.drag_position.height = newRect.height;
			this.drag_position.top = newRect.top;
			this.drag_position.left = newRect.left;
		},
		activateEv(index) {
			this.$refs['drag_input'].focus();
		},
		createFilter(keywords) {
			return item => {
				return (
					item.value.toLowerCase().indexOf(keywords.toLowerCase()) > -1 ||
					item.tel.toString().indexOf(keywords) > -1 ||
					item.job.toLowerCase().indexOf(keywords.toLowerCase()) > -1
				);
			};
		},
		viewit_and_shake(el) {
			el.scrollIntoView()
			const default_color = $(el).css('color')
			const default_background_color = $(el).css('background-color')
			const default_opactiy = $(el).css('opacity')

			let times = 3
			const shake = () => {
				setTimeout(() => {
					if(times > 0){
						$(el).css('color', '#fff')
						$(el).css('background-color', '#64aabc')
						$(el).css('opacity', 1)
						setTimeout(() => {
							$(el).css('color', '#64aabc')
							$(el).css('background-color', '#fff')
							times -= 1
							shake()
						}, 200);
					} else {
						$(el).css('color', default_color)
						$(el).css('background-color', default_background_color)
						$(el).css('opacity', default_opactiy)
						this.active_user_id = null
					}
				}, 300);
			}

			shake()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null;
	},
};
</script>

<style scoped lang="less">
.actives {
	box-sizing: border-box;
	box-shadow: rgb(2, 241, 202) 0px 0px 10px inset;
}
.type_daochu {
	margin-left: 10px;
	width: 170px;
}
/* 已选择座位颜色 */
.xuan {
	background-color: rgb(0 0 0 / 4%);
	color: black;
	border: 2px dotted #514a9d !important;
}
.jy {
	opacity: 0.1;
}
.ckSeat {
	background-color: #f45c43 !important;
	color: white;
}
.nos {
	min-width: 100%;
	white-space: nowrap;
	display: inline-flex;
	margin-bottom: 0px !important;
}
.active {
	box-sizing: border-box;
	// box-shadow: blue 0px 0px 10px inset;
	color: #64aabc;
	border: 1px solid #64aabc !important;
}
.box {
	padding: 10px 40px;
}
.fullscreen_container {
	background-color: #fff;
	transition: all 0.3s ease;
}
.on_fullscreen {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 10;
	overflow: auto;
}
.waibian {
	/* height: 600px; */
	width: calc(100% - 320px - 10px);
	height: auto;
	margin-right: 10px;
	background-color: white;
	overflow: auto;
	transition: all .3s ease;
	transform: scaleY(-1);
	&::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	/* 滚动槽 */
	&::-webkit-scrollbar-track {
		border-radius: 3px;
		background-color: transparent;
	}

	/* 滚动条滑块 */
	&::-webkit-scrollbar-thumb {
		border-radius: 3px;
		background-color: rgba(#64aabc, 0.7);
	}
	.boxs{
		transform: scaleY(-1);
	}
}
.waibian:after {
	/*伪元素是行内元素 正常浏览器清除浮动方法*/
	content: "";
	display: block;
	height: 0;
	clear: both;
	visibility: hidden;
}
.boxs {
	background-color: white;
	padding: 10px 0px 0px 20px;
}

.boxs .left_box ul:after {
	content: "";
	display: block;
	height: 0px;
	clear: both;
}
.boxs .left_box ul {
	list-style: none;
}
.boxs .left_box ul li {
	float: left;
	width: 60px;
	height: 24px;
	text-align: center;
	padding: 0;
	border: 1px solid #707070;
	border-radius: 6px;
	margin-right: 5px;
	margin-bottom: 5px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.seat_active{
	color: #64aabc;
	border: 1px solid #64aabc !important;
}
.boxs .left_box ul li span {
	font-size: 12px;
	display: block;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.text {
	display: inline-block;
	font-size: 14px;
	margin-right: 10px;
}

.item {
	margin-bottom: 10px;
}

.clearfix:before,
.clearfix:after {
	display: table;
	content: "";
}
.clearfix:after {
	clear: both;
}
#card {
	overflow: hidden;
	margin-top: 10px;
	margin-bottom: 0px;
}
.box-card {
	width: 280px;
	float: left;
	margin-right: 10px;
	margin-bottom: 10px;
}

.titile {
	width: 100%;
	display: inline-block;
	overflow: hidden;
	font-weight: 600;
	font-size: 16px;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.order_user > .userbt {
	font-size: 12px;
	width: 60px;
	height: 24px;
	text-align: center;
	border: 1px solid #000;
	border-radius: 6px;
	cursor: pointer;
	margin-bottom: 5px;
	margin-right: 5px;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.order_user .el-button + .el-button {
	margin-left: 0px;
}
.btbox > div {
	padding-bottom: 10px;
	border-bottom: 1px solid #c2cbc2;
}
.waibian_on_dragable{
	width: 100%;
}

.order_user {
	width: 0;
	/* height: 600px; */
	height: auto;
	padding: 15px;
	box-sizing: border-box;
	background-color: white;
	overflow: auto;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-content: flex-start;
	align-items: flex-start;
	flex-wrap: wrap;
	&::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	/* 滚动槽 */
	&::-webkit-scrollbar-track {
		border-radius: 3px;
		background-color: transparent;
	}

	/* 滚动条滑块 */
	&::-webkit-scrollbar-thumb {
		border-radius: 3px;
		background-color: rgba(#64aabc, 0.7);
	}
	.dragable_user_box{
		width: auto;
		padding: 3px 6px;
		background-color: #64aabc;
		border: 1px solid #64aabc;
		border-radius: 4px;
		overflow: hidden;
		box-shadow: 3px 6px 9px rgba(#000, 0.3);
		overflow: hidden;
		transition: all .3s ease;
		cursor: move;
		&::before{
			display: none;
		}
		/deep/ .content-container{
			width: 100%;
			margin: 0;
			padding: 0;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			background-color: #fff;
			.clickbar{
				width: calc(100% + 0px);
				height: 20px;
				min-height: 20px;
				background-color: #64aabc;
				outline: unset;
				transition: all .3s ease;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				cursor: default;
				.icon{
					color: #fff;
					font-size: 14px;
					line-height: 14px;
					margin-right: 10px;
					transition: all .3s ease;
					cursor: pointer;
					&:hover{
						color: rgba(#fff, 1);
						text-shadow: 0 0 9px #fff
					}
				}
			}
			.title_bar{
				width: 100%;
				margin-bottom: 15px;
				padding: 10px;
				padding-bottom: 15px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #bababa;
				cursor: move;
				.drag_input{
					// width: calc(100% - 120px);
					flex: auto;
					margin-right: 10px;
				}
				.select_filter{
					width: 100px;
					min-width: 100px;
				}
			}
			.box_wrapper{
				width: calc(100% - 5px);
				height: calc(100% - 60px);
				margin-right: 5px;
				padding: 0 10px;
				overflow-y: auto;
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;
				align-content: flex-start;
				flex-wrap: wrap;
				overflow-y: auto;
				&::-webkit-scrollbar {
					width: 6px;
					height: 6px;
				}

				/* 滚动槽 */
				&::-webkit-scrollbar-track {
					border-radius: 3px;
					background-color: transparent;
				}

				/* 滚动条滑块 */
				&::-webkit-scrollbar-thumb {
					border-radius: 3px;
					background-color: rgba(#bababa, 0.7);
				}
				.userbt{
					width: auto;
					height: 30px;
					margin: 2px;
					padding: 3px 6px;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #000;
					font-size: 14px;
					font-weight: 400;
					border-radius: 4px;
					transition: all .3s ease;
				}
				.has_seat{
					opacity: 0.5;
				}
				.userbt_active{
					color: #64aabc;
					border: 1px solid #64aabc;
				}
			}
		}
	}
}
.order_user_on_drag_disabled{
	width: 320px;
	padding: 10px;
	border-left: 1px solid #bababa;
	.dragable_user_box{
		width: 100%;
		height: calc(100% + 10px);
		margin-top: -10px;
		padding: 0;
		border: unset;
		box-shadow: unset;
		position: relative;
		top: unset !important;
		left: unset !important;
		background-color: #fff;
		cursor: pointer;
		/deep/ .content-container{
			width: 100% !important;
			height: 100% !important;
			.clickbar{
				background-color: rgba(#000, 0.3);
				cursor: pointer;
				&:hover{
					background-color: rgba(#64aabc, 1);
					.icon{
						color: #fff;
						cursor: pointer;
					}
				}
				.icon{
					color: rgba(#64aabc, 1);
					&:hover{
						text-shadow: 0 0 9px #eedddd;
					}
				}
			}

			.box_wrapper{
				width: 100%;
				height: 100%;
			}
		}
	}
}
</style>